import styled from 'styled-components';
import { ColorSchemeCSSVariable } from './use-color-scheme';

export function Pointer() {
  return (
    <Container>
      <svg
        width="46"
        height="30"
        viewBox="0 0 46 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M46 24.902C46 28.5435 41.3783 31.0083 37.1981 29.5961L2.32965 17.8165C-0.77655 16.7671 -0.77655 13.2329 2.32965 12.1835L37.1981 0.403906C41.3783 -1.00831 46 1.45645 46 5.09802V24.902Z"
          fill="url(#paint0_linear_3646_12263)"
        />

        <BottomLayer />

        <TopLayer />

        <defs>
          <linearGradient
            id="paint0_linear_3646_12263"
            x1="26.3289"
            y1="22.9371"
            x2="18.9843"
            y2="-7.0233"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FAFAFA" />
            <stop offset="1" stopColor="#E7E7E7" />
          </linearGradient>
        </defs>
      </svg>
    </Container>
  );
}

const Container = styled.div`
  position: absolute;
  z-index: 2;
  top: 50%;
  right: -18px;
  transform: translateY(-50%);

  svg {
    display: block;
    filter: drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.25));
  }
`;

const TopLayer = styled.path.attrs({
  d: 'M43.5 22.9216C43.5 24.1239 42.6695 25.2024 41.316 25.8665C39.9697 26.527 38.188 26.7257 36.4945 26.1994L6.17418 16.7757C4.974 16.4027 4.5 15.6418 4.5 15C4.5 14.3582 4.974 13.5973 6.17418 13.2243L36.4945 3.8006C38.188 3.27426 39.9697 3.47297 41.316 4.13352C42.6695 4.79762 43.5 5.87613 43.5 7.07841V22.9216Z'
})`
  fill: var(${ColorSchemeCSSVariable.PointerTopLayerBackground});
  stroke: var(${ColorSchemeCSSVariable.PointerTopLayerBorder});
`;

const BottomLayer = styled.path.attrs({
  d: 'M46 24.902C46 28.5435 41.3783 31.0083 37.1981 29.5961L2.32965 17.8165C-0.77655 16.7671 -0.77655 13.2329 2.32965 12.1835L37.1981 0.403906C41.3783 -1.00831 46 1.45645 46 5.09802V24.902Z'
})`
  fill: var(${ColorSchemeCSSVariable.PointerBottomLayerBackground});
`;
